import { all } from 'redux-saga/effects';

import { examplesSaga } from './example';
import { infoSaga } from './info';
import { simpleProductSaga } from './simpleProduct';
import { meSaga } from './me';
import { checkoutSaga } from './checkout';
import products from './products';
import { shopCartSaga } from './shopCart';
import { checkoutTermsSaga, } from './checkoutTerms';
import { orderSaga, } from './order';
import { checkoutCompleteSaga, } from './checkoutComplete';
import { productsSetSaga } from './productsSet';

function* rootSaga() {
    yield all([
        examplesSaga(),
        infoSaga(),
        meSaga(),
        simpleProductSaga(),
        products.sagas.productsAttributesSaga(),
        products.sagas.collectionSaga(),
        checkoutSaga(),
        shopCartSaga(),
        checkoutTermsSaga(),
        orderSaga(),
        checkoutCompleteSaga(),
        productsSetSaga(),
    ]);
}

export default rootSaga;
